import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ShieldCheckIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full bg-ivory pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-30">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-31">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-32">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="max-w-2xl" data-id="element-33">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-medium leading-tight text-text-brown mb-6 tracking-wide" data-id="element-34">
              Dile adiós a los sofocos y recupera tu cerebro: El kit de
              emergencia para la mujer de 40+ que no tiene tiempo para el
              cansancio.
            </h1>
            <p className="text-lg md:text-xl text-text-brown-light mb-10 font-light leading-relaxed" data-id="element-35">
              Elimina la neblina mental, duerme toda la noche y recupera tu
              energía en 7 días con el Protocolo de Micro-ajustes de 5 minutos.
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4" data-id="element-36">
              <a href="https://kitesencial.com/cart/51775891079488:1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 text-base font-medium text-white bg-terracotta hover:bg-[#b56d50] transition-colors duration-300 rounded-sm shadow-sm w-full sm:w-auto" data-id="element-37">
                Descargar Master-Kit
              </a>
              <div className="flex flex-col gap-1 text-sm text-text-brown-light mt-2 sm:mt-0" data-id="element-38">
                <div className="flex items-center gap-2" data-id="element-39">
                  <ShieldCheckIcon className="w-4 h-4 text-gold" data-id="element-40" />
                  <span data-id="element-41">Acceso instantáneo</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-42">
                  <LockIcon className="w-4 h-4 text-gold" data-id="element-43" />
                  <span data-id="element-44">Pago seguro 100%</span>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative lg:ml-auto w-full max-w-lg mx-auto lg:max-w-none" data-id="element-45">
            <div className="relative w-full aspect-[4/3] rounded-sm overflow-hidden shadow-2xl" data-id="element-46">
              <img src="https://cdn.magicpatterns.com/uploads/jZxdPaqM9NYuJTvgNBm9MH/Gemini_Generated_Image_byg1g5byg1g5byg1.png" alt="Menopause Master-Kit en dispositivos" className="object-cover w-full h-full" data-id="element-47" />
              <div className="absolute inset-0 bg-taupe/10 mix-blend-multiply" data-id="element-48"></div>
            </div>
            {/* Decorative background element */}
            <div className="absolute -z-10 -top-8 -right-8 w-full h-full bg-cream rounded-sm" data-id="element-49"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}